import "./App.css";
import Header from "../HeaderComponent/Header";
import Home from "../HomePage/Home";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Checkout from "../CheckoutPage/Checkout";
import Login from "../LoginPage/Login";
import { useEffect } from "react";
import { auth } from "../../firebase";
import { SetUserAction } from "../../Reducers/AuthenticationReducer";
import { connect } from "react-redux";
import Payment from "../PaymentPage/Payment";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Orders from "../OrderPage/Orders";
import Signup from "../SignupPage/Signup";

const promise = loadStripe(
  "pk_test_51ML4fISI0BqJgCiLjyGyH7LorX0LFZJmCrZzDvGvohCfBKhv4zBnZb5ba0gUxRBAbQTizDu5SNn6q3J5BdfzznPZ00eUsq1aNW"
);

function App({ setUser }) {
  useEffect(() => {
    auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        setUser(authUser);
      } else {
        setUser(null);
      }
    });
  }, []);

  return (
    <Router>
      <div className="app">
        <Switch>
          <Route path="/login">
            <Login />
          </Route>

          <Route path="/signup">
            <Signup />
          </Route>

          <Route path="/checkout">
            <Header />
            <Checkout />
          </Route>

          <Route path="/payment">
            <Header />
            <Elements stripe={promise}>
              <Payment />
            </Elements>
          </Route>

          <Route path="/orders">
            <Header />
            <Orders />
          </Route>

          <Route path="/">
            <Header />
            <Home />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default connect(null, { setUser: SetUserAction })(App);
